import { Avatar,Slider } from "@material-ui/core";
import { useRef, useState} from "react";
import AvatarEditor from "react-avatar-editor";
import "../css/CropCoverPic.css";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { apiClient } from "../apiClient";


const CropWatermarkPic = (props) => {
  var editor = "";

  const [picture, setPicture] = useState({cropperOpen: false,img: null,zoom: 1, 
    croppedImg:process.env.REACT_APP_BACK+`/avatars/${props.avatarPic}`});
  const [hideAvatar,setHideAvatar] = useState(false);
  const [done,setDone] = useState(false);
  const [uploadedFile,setUploadedFile] = useState();
  const [filename,setFilename] = useState();
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('userToken'));
  const toast = useRef(null);
  const handleSlider = (event, value) => {
    setPicture({
      ...picture,
      zoom: value
    });
  };

  const handleCancel = () => {
    setPicture({
      ...picture,
      cropperOpen: false
    });
    setHideAvatar(false);
    setDone(true);
  };

  const setEditorRef = (ed) => {
    editor = ed;
  };

  const handleSave = (e) => {
    if (setEditorRef) {
      const canvasScaled = editor.getImageScaledToCanvas();
      const croppedImg = canvasScaled.toDataURL();

      setPicture({
        ...picture,
        img: null,
        cropperOpen: false,
        croppedImg: croppedImg
      });

      setHideAvatar(false);
      setDone(true);


      //convert croped image to file:
      urltoFile(croppedImg,filename)
      .then((file)=>{
        return setUploadedFile(file);
      });
      ;
    }
  };

  const handleDone = async () =>
  {

    

    //uploading file:
    let formData = new FormData();
    formData.append("file", uploadedFile);

    const config = {  headers: {"Content-Type": "multipart/form-data",Authorization: `Bearer ${token}`} };

    
    await apiClient
      .post(process.env.REACT_APP_BACK+"/users/uploadWatermark/"+props.user_id, formData, config)
      .then((res) => {


          const fileName = res.data.fileName;

        

          const config2 = { headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`, // if applicable
          }}
          //save watermark address in user record:
          const data = { watermark: fileName };

  
    
          apiClient.patch(process.env.REACT_APP_BACK + "/users/update-watermark/" + props.user_id,data, config2)
              .then((response) => {
                  
              })
              .catch((error) => {
                  
              });
          
        
      })
      .catch((error) => 
      {
        
      });


    

    props.close();
  }

  

  const handleFileChange = (e) => {
    const file = e.target.files[0];
  
    if (!file) {
      return; // If no file is selected, exit early
    }
  
    // Check if the file type is PNG
    if (file.type !== "image/png") {
      toast.current.show({severity: 'error', summary:"لطفاً فایل png آپلود کنید" }); 
      return;
    }
  
    // Check if the file size exceeds 2 MB
    const maxSize = 2 * 1024 * 1024; // 2 MB in bytes
    if (file.size > maxSize) {
      toast.current.show({severity: 'error', summary:"اندازه فایل باید کمتر از 2 مگابایت باشد" }); 
      return;
    }
  
    // Proceed with valid file
    let url = URL.createObjectURL(file);
    setPicture({
      ...picture,
      img: url,
      cropperOpen: true,
    });
  
    setHideAvatar(true);
    setFilename(file.name);
  };
  

  const urltoFile=(url, filename, mimeType)=>{
    mimeType = mimeType || (url.match(/^data:([^;]+);/)||'')[1];
    return (fetch(url)
        .then(function(res){return res.arrayBuffer();})
        .then(function(buf){
          return new File([buf], filename, {type:mimeType});
        })
    );
  }

  return (
    
      <div id="crop-avatar">

    <Toast ref={toast} position="center"></Toast>


        <div style={{ display:hideAvatar?"none":"block" }}>
            <div id="show-avatar" >
          <Avatar
          className="avatar"
            src={picture.croppedImg}
            style={{ width: "100%", height: "auto", padding: "5"}}
          />
          </div>
          <h6 style={{marginTop:"20px"}}>تصویر واترمارک خود را آپلود کنید</h6>
          <p style={{direction:"rtl", textAlign:'right'}}>- فرمت فایل انتخابی باید png باشد</p>
          <p style={{direction:"rtl", textAlign:'right'}}>- بهتر است پس زمینه عکس واترمارک، transparent باشد</p>
          <p style={{direction:"rtl", textAlign:'right'}}>- حجم فایل انتخابی باید کمتر از 2 مگابایت باشد</p>
          <button id="brows-button" onClick={()=>setDone(false)}>
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </button>
        </div>

        {picture.cropperOpen && (
          <div id="edit-avatar">
            <AvatarEditor
              ref={setEditorRef}
              image={picture.img}
              width={400}
              height={400}
              border={50}
              color={[255, 255, 255, 0.6]} // RGBA
              rotate={0}
              scale={picture.zoom}
              
            />
            <Slider
              aria-label="raceSlider"
              value={picture.zoom}
              min={1}
              max={10}
              step={0.1}
              onChange={handleSlider}
            ></Slider>
            <div>
              <button variant="contained" onClick={handleCancel}>
                انصراف
              </button>
              <button onClick={handleSave} style={{background:"#219B9D ", color:"#ffffff"}}>ذخیره</button>
            </div>
          </div>
        )}

        <div id="final-save" style={{ display: done ? "block" : "none"}}>
            <Button onClick={handleDone}>همین خوبه!</Button>
        </div>
      </div>
    
  );
};

export default CropWatermarkPic;
